import { call, put } from 'redux-saga/effects';
import { takeEvery } from 'redux-saga';
import config from '../../config';
import request from 'superagent';

export function* getAgeGroups() {
    yield* takeEvery("AGE_GROUPS/FETCH", function* (action) {
        try {
            const result = yield call(() => {
                return request.get(`${config.apiEndpoint}/api/external/rankings/age_groups/all`)
                    .set('Authorization', `Bearer ${config.apiKey}`)
                    .then(data => (JSON.parse(data.text)));
            }, action);

            if (result && result.success) {
                const { boys, girls, base } = result;
                yield put({
                    type: 'AGE_GROUPS/SET',
                    ageGroups: { boys, girls, base }
                });

            } else {
                yield put({
                    type: 'AGE_GROUPS/FETCH_FAILED',
                    result
                });
            }
        } catch (e) {
            yield put({
                type: 'AGE_GROUPS/FETCH_FAILED',
                e
            });
        }
    });
}


// WEBPACK FOOTER //
// ./src/redux-sagas/sagas/rankings.js